import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-24 px-4 bg-cf-darker border-t border-cf-gold/20 relative overflow-hidden" data-id="element-215">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-cf-gold/5 to-transparent pointer-events-none" data-id="element-216" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-217">
        <div className="flex justify-center mb-5 md:mb-8" data-id="element-218">
          <div className="bg-cf-gold/10 p-4 md:p-6 rounded-full border border-cf-gold/30" data-id="element-219">
            <ShieldCheck className="w-12 h-12 md:w-20 md:h-20 text-cf-gold" data-id="element-220" />
          </div>
        </div>

        <h2 className="font-bebas text-3xl md:text-7xl text-white tracking-tight mb-6 md:mb-8 leading-tight" data-id="element-221">
          GARANTÍA CROSSFIT RESUELTO — 7 DÍAS
        </h2>

        <div className="bg-cf-card border border-white/10 p-5 md:p-12 rounded-2xl mb-6 md:mb-8" data-id="element-222">
          <p className="text-base md:text-2xl text-gray-200 font-medium leading-relaxed mb-4 md:mb-6" data-id="element-223">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés. Si en 7 días no es lo que esperabas:{' '}
            <span className="text-cf-gold font-bold" data-id="element-224">
              Te devolvemos el 100%.
            </span>{' '}
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="text-sm md:text-lg text-gray-400" data-id="element-225">
            La confianza que tenemos en CROSSFIT RESUELTO nos permite hacer esa
            promesa sin dudar. Más de 500 instructores de Crossfit de todo el
            país ya lo saben. La tasa de devoluciones es menor al 1%.
          </p>
        </div>
      </div>
    </section>;
}